import { Directive, ElementRef, EventEmitter, HostListener, NgZone, Output } from '@angular/core';

@Directive({
  selector: '[appClickedOutside]',
  standalone: false,
})
export class ClickedOutsideDirective {
  @Output() clickOutside: EventEmitter<Event> = new EventEmitter<Event>();
  constructor(private _elm: ElementRef, private _ngZone: NgZone) { }

  @HostListener('document:click', ['$event', '$event.target'])
  onClick(event: MouseEvent, targetElement: HTMLElement) {
    if (!targetElement) {
      return;
    }
    const clickedInside = (this._elm?.nativeElement as HTMLElement).contains(targetElement);
    if (!clickedInside) {
      this.clickOutside.next(event);
    }
  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.clickOutside.next(event);
    }
  }
}
